import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagWF = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#002654",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#CE1126",
  d: "M0 25h20V.5c1-.193 2.5-.5 5-.5 13.807 0 25 11.193 25 25S38.807 50 25 50 0 38.807 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#fff",
  d: "M10 25V5A24.885 24.885 0 0 1 20 .5V25H10ZM32 31l-6-6h12l-6 6ZM32 35l6 6H26l6-6ZM30 33l-6 6V27l6 6ZM34 33l6-6v12l-6-6Z"
}));
FlagWF.displayName = 'FlagWF';
export default withFlagWrapper(FlagWF);
//# sourceMappingURL=index.js.map